<template>
  <div class="news">
    <component :is="currentTabComponent"></component>
    <HomeFooter/>
  </div>
</template>

<script>
import HomeFooter from "../home/components/footer";
const A1 = () => import("./components/a1" /*webpackChunkName: 'a1' */);
const A2 = () => import("./components/a2" /*webpackChunkName: 'a2' */);
const A3 = () => import("./components/a3" /*webpackChunkName: 'a3' */);
const A4 = () => import("./components/a4" /*webpackChunkName: 'a4' */);
const A5 = () => import("./components/a5" /*webpackChunkName: 'a5' */);
const A6 = () => import("./components/a6" /*webpackChunkName: 'a6' */);
const A7 = () => import("./components/a7" /*webpackChunkName: 'a7' */);
const A8 = () => import("./components/a8" /*webpackChunkName: 'a8' */);
const A9 = () => import("./components/a9" /*webpackChunkName: 'a9' */);
const A10 = () => import("./components/a10" /*webpackChunkName: 'a10' */);
const A11 = () => import("./components/a11" /*webpackChunkName: 'a11' */);
const A12 = () => import("./components/a12" /*webpackChunkName: 'a12' */);
const A13 = () => import("./components/a13" /*webpackChunkName: 'a13' */);
const A14 = () => import("./components/a14" /*webpackChunkName: 'a14' */);
const A15 = () => import("./components/a15" /*webpackChunkName: 'a15' */);
const B1 = () => import("./components/b1" /*webpackChunkName: 'b1' */);
const B2 = () => import("./components/b2" /*webpackChunkName: 'b2' */);
const B3 = () => import("./components/b3" /*webpackChunkName: 'b3' */);
const B4 = () => import("./components/b4" /*webpackChunkName: 'b4' */);
const B5 = () => import("./components/b5" /*webpackChunkName: 'b5' */);
const B6 = () => import("./components/b6" /*webpackChunkName: 'b6' */);
const B7 = () => import("./components/b7" /*webpackChunkName: 'b7' */);
const B8 = () => import("./components/b8" /*webpackChunkName: 'b8' */);
const B9 = () => import("./components/b9" /*webpackChunkName: 'b9' */);
const B10 = () => import("./components/b10" /*webpackChunkName: 'b10' */);
const B11 = () => import("./components/b11" /*webpackChunkName: 'b11' */);
const B12 = () => import("./components/b12" /*webpackChunkName: 'b12' */);
const B13 = () => import("./components/b13" /*webpackChunkName: 'b13' */);
const B14 = () => import("./components/b14" /*webpackChunkName: 'b14' */);
const B15 = () => import("./components/b15" /*webpackChunkName: 'b15' */);
const C1 = () => import("./components/c1" /*webpackChunkName: 'c1' */);
const C2 = () => import("./components/c2" /*webpackChunkName: 'c2' */);
const C3 = () => import("./components/c3" /*webpackChunkName: 'c3' */);
const C4 = () => import("./components/c4" /*webpackChunkName: 'c4' */);
const C5 = () => import("./components/c5" /*webpackChunkName: 'c5' */);
const D1 = () => import("./components/d1" /*webpackChunkName: 'd1' */);
const D2 = () => import("./components/d2" /*webpackChunkName: 'd2' */);
const D3 = () => import("./components/d3" /*webpackChunkName: 'd3' */);
const D4 = () => import("./components/d4" /*webpackChunkName: 'd4' */);
const D5 = () => import("./components/d5" /*webpackChunkName: 'd5' */);
const D6 = () => import("./components/d6" /*webpackChunkName: 'd6' */);

const media1 = () =>
  import("../publicWelfare/components/newsone" /*webpackChunkName: 'media1' */);
const media2 = () =>
  import("../publicWelfare/components/newstwo" /*webpackChunkName: 'media2' */);
const media3 = () =>
  import("../publicWelfare/components/newsthree" /*webpackChunkName: 'media3' */);

const report1 = () =>
  import("../publicWelfare/components/newsfour" /*webpackChunkName: 'report1' */);
const report2 = () =>
  import("../publicWelfare/components/newsfive" /*webpackChunkName: 'report2' */);
const report3 = () =>
  import("../publicWelfare/components/newssix" /*webpackChunkName: 'report3' */);

export default {
  name: "news",
  components: {
    HomeFooter,
    A1,
    A2,
    A3,
    A4,
    A5,
    A6,
    A7,
    A8,
    A9,
    A10,
    A11,
    A12,
    A13,
    A14,
    A15,
    B1,
    B2,
    B3,
    B4,
    B5,
    B6,
    B7,
    B8,
    B9,
    B10,
    B11,
    B12,
    B13,
    B14,
    B15,
    C1,
    C2,
    C3,
    C4,
    C5,
    D1,
    D2,
    D3,
    D4,
    D5,
    D6,
    media1,
    media3,
    media2,
    report1,
    report2,
    report3
  },
  data() {
    return {
      currentTabComponent: ""
    };
  },
  mounted() {
    this.currentTabComponent = this.$route.params.id;
  }
};
</script>

<style lang="scss">
.news {
  .news-all {
    width: 1000px;
    margin: 0 auto;
    padding-bottom: 50px;
    .title {
      height: 68px;
      margin-top: 40px;
      display: flex;
      .time {
        width: 88px;
        height: 68px;
        background: #bedccb;
        float: left;
        color: #fff;
        text-align: center;
        font-size: 24px;
        line-height: 1.2;
        padding-top: 8px;
        margin-right: 20px;
      }
      .tiel {
        flex: 1;
        font-size: 24px;
        padding-top: 34px;
        white-space: nowrap;
        overflow: hidden;
      }
    }
    .mat-content {
      margin-top: 35px;
      font-size: 16px;
      .tet-js {
        margin-top: 24px;
        line-height: 2;
        color: #4a4a4a;
      }
    }
  }
  img {
    margin: 20px 0 10px;
  }

  b,
  strong {
    font-weight: bolder;
  }
}
</style>
